import axiosClient, { AxiosResponse } from 'axios';
import { ChangePayload } from '@nx-frontend/shared/types';
import { getChatOptions } from '@nx-frontend/shared/utils/blocks';

// POST

export const createChatConfiguration = async (
  payload: ChangePayload,
  apiUrl: string,
  orgId: string,
  workspaceId: string,
  portalId: string,
  id: string,
  sessionId: string
): Promise<AxiosResponse> => {
  const options = getChatOptions(payload);

  const body = {
    type: 'portalWidget',
    portalId,
    widgetId: id,
    title: payload.title,
    options,
  };

  return axiosClient.post(`${apiUrl}/configurations?orgId=${orgId}&scope=${workspaceId}`, body, {
    headers: { 'session-id': sessionId },
  });
};
